<template>
  <div id="workflow-edit-json">
    <div class="modal workflow-edit-json-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <p class="header has-text-info">
            {{ w.workflow_type_name }}
            <span class="is-pulled-right">Edit Workflow</span>
          </p>

          <div class="field" style="margin-bottom: -4px">
            <p class="control">
              <input
                class="input is-white"
                v-model="w.name"
                type="text"
                placeholder="Workflow Name"
              />
              <!-- <span class="icon is-small is-left">
                <i class="fas fa-signature"></i>
              </span> -->
            </p>
          </div>

          <div class="field">
            <div class="control">
              <textarea
                class="textarea is-grey has-text-weight-medium no-scrollbar"
                style="background-color: slategrey"
                :style="jsonStyle"
                v-model="dataJSON"
                placeholder="Data JSON"
              ></textarea>
            </div>
          </div>

          <div class="field is-grouped">
            <p class="control">
              <button
                class="button is-warning is-rounded"
                :class="{ 'is-danger': invalidJSON }"
                @click="parseJSON"
              >
                <span class="icon" style="margin-right: 4px">
                  <i class="fa fa-pencil-alt" /> </span
                >Parse
              </button>
            </p>
            <p class="control is-expanded">
              <button
                class="button is-success is-fullwidth is-rounded"
                @click="submit"
              >
                Update
              </button>
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
// const stringify = require("json-stringify-pretty-compact");

export default {
  name: "WorkflowEditJSON",
  components: {},
  data() {
    return {
      w: {
        name: "",
      },
      workflowName: null,
      //   workflowInfo: null,
      //   phoneNumber: null,
      //   operatingHours: null,
      dataJSON: null,
      invalidJSON: false,
    };
  },
  computed: {
    jsonStyle() {
      if (this.invalidJSON) return "color:lightpink";
      return "color:#fffd00"; // light yellow
    },
  },
  mounted() {
    EventBus.$on("EDIT_WORKFLOW_JSON", (w) => {
      this.console("edit workflow json", w);
      this.w = w;
      this.workflowName = null;
      //   this.workflowInfo = w.info;
      //   this.workflowInfo = w.phone_number;
      //   var jsonStr = w.data;
      //   if (w.data === "{}") jsonStr = null;
      //   this.dataJSON = this.prettyJSON(w.data);
      this.dataJSON = JSON.stringify(w.data, null, 2);
      //   this.dataJSON = stringify(w.data);
    });
  },
  methods: {
    closeModal() {
      this.workflowName = "Tuk Tuk"; // reset data
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    prettyJSON(str) {
      //   console.log("pretty", str);
      return JSON.stringify(JSON.parse(str), null, 2);
      //   return JSON.stringify(o, null, 2);
    },
    isValidJSON() {
      try {
        JSON.parse(this.dataJSON);
      } catch (e) {
        this.invalidJSON = true;
        return false;
      }
      this.invalidJSON = false;
      return true;
    },
    parseJSON() {
      var loader = this.loadingDots("lightgreen");
      if (this.isValidJSON()) {
        this.dataJSON = this.prettyJSON(this.dataJSON);
        // this.dataJSON = stringify(this.dataJSON);
      } else {
        console.log("invalid JSON");
      }
      setTimeout(() => loader.hide(), 200);
    },
    submit() {
      this.parseJSON();
      if (this.invalidJSON) {
        var msg = `Invalid JSON<br><br>Check keys are quoted<br>and comma-separated`;
        return this.errorToast(msg, "top");
      }
      var businessID = this.$store.state.selectedBusiness.id;
      var loader = this.loadingDots("lightgreen");
      console.log("updateWorkflow", this.w);
      this.$store
        .dispatch("updateWorkflow", {
          id: this.w.id,
          business_id: this.w.business_id,
          name: this.w.name,
          data: JSON.parse(this.dataJSON),
          // { phone_number: this.phoneNumber, info: this.workflowInfo, operating_hours: this.operatingHours }
        })
        .then(() => {
          this.$store
            .dispatch("getWorkflows", businessID)
            .then(() => {
              this.closeModal();
              // this.success(); // successModal mixin
              this.successToast("JSON Saved!", "top");
            })
            .catch((err) => this.apiError(err));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  max-width: 640px;
  padding: 10px;
  border-radius: 25px;
}
.field {
  margin-bottom: 6px;
}
textarea {
  /* border-radius: 10px; */
  height: calc(80vh - 150px);
}
.header {
  text-align: left;
  font-size: 1.3em;
  font-weight: 500;
  padding-left: 8px;
}
.header span {
  color: black;
  opacity: 0.5;
  font-size: 0.9em;
}
</style>